import { Box, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import CatalogBenefits from '/@/components/catalogBenefits';
import Hybrids from '/@/components/hybrids';
import settings from '/@/core/settings';
import { useAllCatalogProducts, useCornTechnologies } from '/@/hooks/catalog';
import { _ } from '/@/locale';
import { getActiveBrands } from '/@/store/bag-quality/selectors';
import { getSessionCountry } from '/@/store/session/selectors';
import { isMobile } from '/@/utils';
import Title from '/@/v3/components/title';
import CurvedShape from './curve';
import styles from './styles.module.css';

const DKProtect = () => {
    const country = useSelector(getSessionCountry);
    const cornBrands = useSelector((state) => getActiveBrands(state, 'corn'));
    const productsQuery = useAllCatalogProducts({
        country: country.code,
        brand: cornBrands?.[0].name,
        crop: 'corn',
    });

    const technologiesQuery = useCornTechnologies({ page: 1, pageSize: 10000 });
    const dKProtectTechnology = useMemo(() => {
        if (!productsQuery.data) return [];
        const dkProducts = (technologiesQuery.data?.results || []).find((t) => t.name === 'DKProtect')?.profiles || [];
        return dkProducts
            .map((p) => productsQuery.data?.results.find((productData) => productData.id === p))
            .filter(Boolean);
    }, [technologiesQuery, productsQuery.data]);

    const renderBenefits = () => {
        return (
            <div className={styles.benefits}>
                <div className={styles.messageWrapper}>
                    <CatalogBenefits
                        number='1'
                        message={_('Un escudo seguro que lleva al máximo la potencia del germoplasma.')}
                    />
                </div>
                <div className={styles.messageWrapper}>
                    <CatalogBenefits
                        number='2'
                        message={_(
                            'La máxima protección disponible contra Mal de Río Cuarto, Tizón y Roya en la zona templada.'
                        )}
                    />
                </div>
                <div className={styles.messageWrapper}>
                    <CatalogBenefits
                        number='3'
                        message={_('Asegura rendimiento y estabilidad en el desarrollo del cultivo.')}
                    />
                </div>
            </div>
        );
    };
    const theme = useTheme();

    return (
        <Box sx={{ position: 'relative', overflow: 'hidden' }}>
            <Box sx={{ position: 'absolute', bottom: -5, zIndex: 1, display: { xs: 'none', xl: 'block' } }}>
                <CurvedShape fill={theme.palette.primary.main} />
            </Box>
            <div className={styles.root}>
                <div className={styles.layout}>
                    <div className={styles.logoContainer}>
                        <div className={styles.logo} />
                    </div>

                    <div className={styles.description}>
                        <div className={styles.title}>
                            <div className={styles.titleWrapper}>
                                <Title className={styles.text}>{_('Genética')}</Title>
                                <Title className={styles.text}>{_('que')}</Title>
                            </div>
                            <div className={styles.titleWrapper}>
                                <Title className={styles.text} theme={settings.app.theme}>
                                    {_('protege')}
                                </Title>
                                <Title className={styles.text}>{_('tu')}</Title>
                                <Title className={styles.text}>{_('cultivo')}</Title>
                            </div>
                        </div>
                        <Title size='md'>
                            {_(
                                'Bienvenidos a la protección segura de Dekalb, genética pura que rinde y respalda el poder de tu maíz. '
                            )}
                        </Title>
                    </div>
                    <div className={styles.hybrids}>
                        <Title className={styles.hybridsTitle}>{_('Híbridos Disponibles')}</Title>
                        <div className={styles.hybridsContainer}>
                            {dKProtectTechnology.map((hybrid) => {
                                return <Hybrids key={hybrid.id} hybrid={hybrid.catalogName} />;
                            })}
                        </div>
                    </div>
                    {!isMobile() && renderBenefits()}
                    {isMobile() && <div className={styles.cardsContainer}>{renderBenefits()}</div>}
                </div>
                <br />
                <br />
            </div>
        </Box>
    );
};

export default DKProtect;
